/* jshint esversion: 6 */
import React, { useState } from "react";
import { IoSearch, IoClose } from "react-icons/io5";

const EMOJI_CATEGORIES = [
  {
    id: "smileys",
    name: "Smileys",
    icon: "😊",
    emojis: [
      "😊", "😂", "🤣", "😃", "😄", "😅", "😆", "😉", "😍", "🥰", "😘", "😗", "😚", "😋", "😛", "😜", "🤪", "😝", "🤑", "🤗", "🤭", "🤫", "🤔", "🤐", "🤨", "😐", "😑", "😶", "😏", "😒", "🙄", "😬", "😮", "🥱", "😴", "😌", "😎", "🤓", "🧐", "😕", "😟", "🙁", "😮", "😯", "😲", "😳", "🥺", "😦", "😧", "😨", "😰", "😥", "😢", "😭", "😱", "😖", "😣", "😞", "😓", "😩", "😫", "😤", "😡", "😠", "🤬", "😈", "👿", "💀", "💩", "🤡"
    ]
  },
  {
    id: "love",
    name: "Hearts & Love",
    icon: "❤️",
    emojis: [
      "❤️", "💖", "💗", "💓", "💞", "💕", "💘", "💌", "❣️", "💔", "🧡", "💛", "💚", "💙", "💜", "🤎", "🖤", "🤍", "💋", "💎", "💐", "🌸", "🌺", "🌹", "🌷", "🌻"
    ]
  },
  {
    id: "hands",
    name: "Hands & Gestures",
    icon: "👍",
    emojis: [
      "👍", "👎", "👏", "🙌", "🤲", "🤝", "🙏", "✌️", "🤟", "🤘", "👌", "🤏", "👈", "👉", "👆", "👇", "☝️", "✋", "🤚", "🖐️", "🖖", "👋", "💪", "👊", "✊", "🤝"
    ]
  },
  {
    id: "party",
    name: "Party & Fun",
    icon: "🎉",
    emojis: [
      "🎉", "🥳", "🎊", "🎂", "🎈", "🎁", "🍾", "🥂", "🍻", "🍹", "🍸", "🍷", "🎵", "🎶", "🎤", "🎧", "🎸", "🏆", "🥇", "⭐", "🌟", "✨", "💥", "🔥", "💯"
    ]
  },
  {
    id: "food",
    name: "Food & Drinks",
    icon: "🍕",
    emojis: [
      "🍕", "🍔", "🍟", "🌭", "🍿", "🥓", "🍳", "🧇", "🥞", "🍞", "🥐", "🥖", "🧀", "🥗", "🥪", "🌮", "🌯", "🍝", "🍜", "🍲", "🍣", "🍱", "🥟", "🍧", "🍨", "🍦", "🍰", "🍩", "🍪", "🍫", "🍬", "🍭", "☕", "🧃", "🥤", "🍺", "🍻", "🥂", "🍷"
    ]
  },
  {
    id: "animals",
    name: "Animals & Nature",
    icon: "🐱",
    emojis: [
      "🐱", "🐶", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼", "🐨", "🐯", "🦁", "🐮", "🐷", "🐸", "🐵", "🙈", "🙉", "🙊", "🐒", "🐔", "🐧", "🐦", "🐤", "🦆", "🦅", "🦉", "🦇", "🐺", "🐴", "🦄", "🐝", "🦋", "🐌", "🐞", "🐢", "🐍", "🐙", "🐬", "🐳", "🦈"
    ]
  }
];

const CustomEmojiPicker = ({ onSelect, onClose }) => {
  const [activeTab, setActiveTab] = useState("smileys");
  const [search, setSearch] = useState("");

  // Filter emojis when search is used
  const allEmojis = EMOJI_CATEGORIES.flatMap((cat) => cat.emojis);
  const filteredEmojis = search.trim()
    ? allEmojis.filter((e) => e.includes(search.trim()))
    : null;

  const currentCategory = EMOJI_CATEGORIES.find((cat) => cat.id === activeTab) || EMOJI_CATEGORIES[0];

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className="w-[320px] bg-white rounded-3xl shadow-2xl border border-purple-200/90 overflow-hidden flex flex-col transition-all duration-200 animate-in fade-in slide-in-from-bottom-2 select-none"
      style={{
        boxShadow: "0 20px 45px -10px rgba(147, 51, 234, 0.3), 0 0 20px rgba(0,0,0,0.06)"
      }}
    >
      {/* HEADER BAR */}
      <div className="bg-gradient-to-r from-purple-600 via-purple-700 to-indigo-600 px-4 py-3 text-white flex items-center justify-between">
        <span className="font-bold text-xs flex items-center gap-1.5 tracking-wide">
          <span className="text-base">😊</span> Expression Gallery
        </span>
        <button
          onClick={onClose}
          type="button"
          className="text-white/80 hover:text-white p-1 rounded-full hover:bg-white/15 transition-colors border-0 bg-transparent"
        >
          <IoClose size={16} />
        </button>
      </div>

      {/* SEARCH INPUT BAR */}
      <div className="p-3 bg-purple-50/50 border-b border-purple-100/80">
        <div className="relative flex items-center">
          <IoSearch className="absolute left-3 text-purple-400 text-sm" />
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search emojis..."
            className="w-full pl-9 pr-3 py-1.5 bg-white rounded-full text-xs text-gray-800 border border-purple-200 focus:outline-none focus:border-purple-500 placeholder:text-gray-400 shadow-sm"
          />
          {search && (
            <button
              onClick={() => setSearch("")}
              className="absolute right-2.5 text-gray-400 hover:text-gray-600 text-xs border-0 bg-transparent"
            >
              ×
            </button>
          )}
        </div>
      </div>

      {/* CATEGORY TABS (when not searching) */}
      {!search && (
        <div className="flex items-center justify-around px-2 py-1.5 bg-white border-b border-gray-100">
          {EMOJI_CATEGORIES.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveTab(cat.id)}
              className={`p-1.5 rounded-xl text-base transition-all border-0 bg-transparent ${
                activeTab === cat.id
                  ? "bg-purple-100 scale-110 shadow-sm"
                  : "hover:bg-gray-100 opacity-70 hover:opacity-100"
              }`}
              title={cat.name}
            >
              {cat.icon}
            </button>
          ))}
        </div>
      )}

      {/* EMOJI GRID */}
      <div className="p-3 max-h-[220px] overflow-y-auto custom-theme-scrollbar">
        {filteredEmojis ? (
          <div>
            <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block mb-2">
              Search Results ({filteredEmojis.length})
            </span>
            <div className="grid grid-cols-7 gap-1.5">
              {filteredEmojis.map((emoji, idx) => (
                <button
                  key={idx}
                  onClick={() => onSelect(emoji)}
                  className="w-8 h-8 flex items-center justify-center text-xl hover:scale-125 hover:bg-purple-100/70 rounded-xl transition-all border-0 bg-transparent active:scale-95 cursor-pointer"
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
        ) : (
          <div>
            <span className="text-[10px] font-bold text-purple-600 uppercase tracking-wider block mb-2">
              {currentCategory.name}
            </span>
            <div className="grid grid-cols-7 gap-1.5">
              {currentCategory.emojis.map((emoji, idx) => (
                <button
                  key={idx}
                  onClick={() => onSelect(emoji)}
                  className="w-8 h-8 flex items-center justify-center text-xl hover:scale-125 hover:bg-purple-100/70 rounded-xl transition-all border-0 bg-transparent active:scale-95 cursor-pointer"
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* FOOTER QUICK REACTION */}
      <div className="px-3 py-2 bg-gray-50 border-t border-gray-100 flex items-center justify-between text-[11px] text-gray-500">
        <span>Click to insert</span>
        <span className="font-semibold text-purple-600">GoMeet Emoji</span>
      </div>
    </div>
  );
};

export default CustomEmojiPicker;
